import script from "./NewcomerRedPacketPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewcomerRedPacketPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewcomerRedPacketPopup.vue?vue&type=style&index=0&id=6de7e73f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de7e73f"]])

export default __exports__